var $a8f49035a51fdb32$exports = {};
$a8f49035a51fdb32$exports = {
    "longPressMessage": `\u{AE38}\u{AC8C} \u{B204}\u{B974}\u{AC70}\u{B098} Alt + \u{C544}\u{B798}\u{CABD} \u{D654}\u{C0B4}\u{D45C}\u{B97C} \u{B20C}\u{B7EC} \u{BA54}\u{B274} \u{C5F4}\u{AE30}`
};


export {$a8f49035a51fdb32$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
